import React from 'react';

function ProjectModal({ project, open, onClose }) {
  if (!open || !project) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" role="dialog" aria-modal="true" aria-labelledby="project-modal-title">
      <div className="bg-gray-900 border-2 border-neon rounded-md max-w-4xl w-full p-6">
        <div className="flex justify-between items-start mb-4">
          <h3 id="project-modal-title" className="text-lg neon-text">{project.title}</h3>
          <button aria-label="Close project" className="text-neon hover:text-white" onClick={onClose}>✕</button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <img src={project.screenshot} alt={`${project.title} screenshot`} className="w-full rounded border border-gray-800" />
          </div>
          <div>
            <p className="mb-4">{project.description}</p>
            <p className="mb-4 text-sm text-neon">Tech: {project.tech.join(', ')}</p>
            <div className="flex gap-4">
              <a href={project.demo} target="_blank" rel="noopener noreferrer" className="text-neon underline">Live Demo</a>
              <a href={project.github} target="_blank" rel="noopener noreferrer" className="text-neon underline">GitHub</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectModal;